import * as LucideIcons from 'lucide-react'

/**
 * Shared TeamMark — kabinet team-identiteit.
 * Priority: logo_url > icon_name > placeholder (initialen).
 *
 * Props (accepteert BOTH team.foo EN team.team_foo shape voor JOINed rows):
 *   icon_name   | team_icon_name   : string zoals 'Trophy' (matcht lucide-react export)
 *   icon_color  | team_icon_color  : hex accent (default '#B4FF39' = acid)
 *   logo_url    | team_logo_url    : uploaded logo (wint alles)
 *   name        | team_name        : voor initialen-fallback
 *   size        : 'sm' | 'md' | 'lg'
 */
export default function TeamMark(props) {
  const icon_name   = props.icon_name   ?? props.team_icon_name
  const icon_color  = props.icon_color  ?? props.team_icon_color ?? '#B4FF39'
  const logo_url    = props.logo_url    ?? props.team_logo_url
  const name        = props.name        ?? props.team_name ?? ''
  const size        = props.size ?? 'md'

  const sizeCls = size === 'lg' ? 'h-14 w-14'
                 : size === 'sm' ? 'h-8 w-8'
                 : 'h-10 w-10'

  if (logo_url) {
    const wh = size === 'lg' ? 'h-14 w-14' : size === 'sm' ? 'h-8 w-8' : 'h-10 w-10'
    return <img src={logo_url} alt="" className={`${wh} object-contain rounded-[4px] border border-border bg-card shrink-0`} />
  }

  if (icon_name) {
    const Icon = LucideIcons[icon_name] ?? LucideIcons.Flag
    const iconSize = size === 'lg' ? 32 : size === 'sm' ? 16 : 22
    return (
      <div
        className={`${sizeCls} rounded-[4px] border border-border flex items-center justify-center shrink-0 bg-card`}
        style={{ borderLeft: `2px solid ${icon_color}` }}
      >
        <Icon size={iconSize} style={{ color: icon_color }} strokeWidth={2.2} />
      </div>
    )
  }

  // Placeholder: initialen op hairline-card
  const initials = (name || '?').split(/\s+/).filter(Boolean).slice(0, 2).map(w => w[0]).join('').toUpperCase() || '?'
  const textCls = size === 'lg' ? 'text-lg' : size === 'sm' ? 'text-[10px]' : 'text-xs'
  return (
    <div className={`${sizeCls} rounded-[4px] border border-dashed border-border/60 flex items-center justify-center shrink-0 bg-card`}>
      <span className={`font-mono ${textCls} uppercase tracking-widest text-muted-foreground`}>{initials}</span>
    </div>
  )
}

/**
 * Backwards-compat: sommige oude callers importeerden parseFlag.
 * Behouden zodat sweep-imports niet breken; retourneert altijd null zodat er geen vlag getekend wordt.
 */
export function parseFlag() { return null }
